import { useEffect, type ReactNode } from 'react'
import { BrandLockup } from '@/components/brand/BrandLockup'
import { StatusBarStrip } from '@/components/layout/StatusBarStrip'

/**
 * The frame every signed-out auth page shares (sign-in, accept invitation,
 * PB-75): muted page, a narrow centred column, the MNTND lockup on top, then
 * the page's notices and card. The strip keeps the iPhone status bar the
 * page's grey (PB-78). While it's open the root and body are grey too, so
 * pulling the page down on an iPhone doesn't show a dark band (D112).
 */
export function AuthPageFrame({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.documentElement.classList.add('auth-page')
    return () => document.documentElement.classList.remove('auth-page')
  }, [])

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <StatusBarStrip className="bg-muted" />
      <div className="flex w-full max-w-sm flex-col gap-6">
        <BrandLockup className="h-9 self-center" />
        {children}
      </div>
    </div>
  )
}

/** The line between the provider buttons and the email option. */
export function AuthDivider({ label }: { label: string }) {
  return (
    <div className="relative text-center text-sm after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t after:border-border">
      <span className="relative z-10 bg-card px-2 text-muted-foreground">
        {label}
      </span>
    </div>
  )
}
